import { render, staticRenderFns } from "./OpenTerminalBatchForm.vue?vue&type=template&id=6bdf129e&scoped=true&"
import script from "./OpenTerminalBatchForm.vue?vue&type=script&lang=js&"
export * from "./OpenTerminalBatchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdf129e",
  null
  
)

export default component.exports